"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveTaxVatNumber = exports.getTaxVatNumbers = void 0;
var _mainConfig = require("../mainConfig");
var _taxNumberApi = _interopRequireDefault(require("../cic/api/taxNumberApi"));
var _myDataApi = _interopRequireDefault(require("../csc/api/myDataApi"));
var currentApiSet = _mainConfig.isCICContentTree ? _taxNumberApi.default : _myDataApi.default;
var getTaxVatNumbers = exports.getTaxVatNumbers = currentApiSet.getTaxVatNumbers,
  saveTaxVatNumber = exports.saveTaxVatNumber = currentApiSet.saveTaxVatNumber;